/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartialRole
 */
export interface PartialRole {
    /**
     * 
     * @type {number}
     * @memberof PartialRole
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialRole
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRole
     */
    notes?: string;
}

/**
 * Check if a given object implements the PartialRole interface.
 */
export function instanceOfPartialRole(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PartialRoleFromJSON(json: any): PartialRole {
    return PartialRoleFromJSONTyped(json, false);
}

export function PartialRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartialRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function PartialRoleToJSON(value?: PartialRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'notes': value.notes,
    };
}

